import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter, Link } from 'react-router-dom';
import PickingService from '../../../services/PickingService';
import * as orderGroupAction from '../../../actions/orderGroupAction';
import { translate, formatData, enumText, getUserNameToName, makeEnum, isNullOrEmpty } from '../../../utils/util';
import { ENUMS, PERMISSIONS } from '../../../utils/constants'
import { Breadcrumbs, ListPagination, Input, Select, Button } from '../../../components/UI/ComponentsUI';
import DeliveryService from '../../../services/DeliveryService';
import { checkPermission } from '../../../services/auth';
import { onValueChange } from '../../../utils/handleChangeHooks';
import M from 'materialize-css/dist/js/materialize';

const OrderGroupList = (props) => {
    const groupType = props.location?.state?.groupType;
    const manageOrder = checkPermission(PERMISSIONS.Delivery.ManageLineDelivery);
    const [currentPage, setCurrentPage] = useState(0);
    const [orderGroups, setOrderGroups] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const [arrayDrop, setArrayDrop] = useState([]);
    const [filter, setFilter] = useState({
        creationDate: undefined,
        status: [],
        orderGroupId: ''
    })
    const [instanceM, setInstanceM] = useState();
    
    useEffect(() => {
        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        setInstanceM(instance);

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.orderGroups?.items?.length > 0) {
            if (orderGroups.length > 0 && currentPage === 0) {
                setOrderGroups(props.orderGroups.items);
            } else {
                setOrderGroups((prevState) => ([...prevState, ...props.orderGroups.items]));
            }
        } else {
            setOrderGroups([]);
        }
        var drop = makeEnum(ENUMS.eOrderGroupStatus).map((i) => {
            return { id: i.value, text: translate(i.text, 'expedition') };
        });
        setArrayDrop(drop);
        // eslint-disable-next-line
    }, [props?.orderGroups?.items]);

    useEffect(() => {
        getGroupFilter();
        // eslint-disable-next-line
    }, [currentPage, refresh]);

    const getGroupFilter = () => {
        const filterDto = {
            ...filter,
            groupType: groupType,
            PageSize: 25,
            PageIndex: currentPage
        };

        props.getOrdersGroup(filterDto);
        if(instanceM) instanceM[1].close();
    }

    const getStatusGrouOrder = (value) => translate(`expedition:${enumText(ENUMS.eOrderGroupStatus, value)}`);

    const onFilter = () => {
        setCurrentPage(0);
        setRefresh(refresh + 1)
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const removedStatusFilter = (id) => {
        const items = filter.status.filter((item) => Number(item) !== Number(id));
        if (items) {
            const filterObj = {}
            Object.assign(filterObj, filter);
            filterObj.status = items;
            setFilter(filterObj);
        }
    }

    const addStatusFilter = (item) => {
        const itemSelect = item.currentTarget.options[item.currentTarget.selectedIndex];
        if (!isNullOrEmpty(itemSelect?.value)) {
            const id = Number(itemSelect.value);
            const filterObj = {}
            Object.assign(filterObj, filter);
            if (!filter.status.find((f) => Number(f.id) === Number(id))) {
                filterObj.status.push(id);
                setFilter(filterObj);
            }
        }
    };

    return (
        <div>
            <Breadcrumbs id="orderGroupsTitle" title={{ icon: "mdi mdi-clipboard-list-outline", label: translate('line-picking:linepicking.group') }} />
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <ul id='collapsible' className="collapsible">
                        <li className='active'>
                            <div className="collapsible-header">
                                {translate('expedition:picking.filter')}
                            </div>
                            <div className="collapsible-body" style={{ padding: '10px', backgroundColor: '#fff' }}>  
                                <div className="row">
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            id="orderGroupId"
                                            name='orderGroupId'
                                            placeholder={translate('line-picking:linepicking.group')}
                                            type="number"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Select
                                            id="status"
                                            name="status"
                                            display="description"
                                            defaultValue={""}
                                            change={addStatusFilter}
                                            placeHolder={`Status - ${translate('general:choose-one-option')}`}
                                            data={arrayDrop}
                                        />
                                    </div> 
                                    <div className="input-field no-padding col s5" style={{ marginTop: '28px' }}>
                                        <Input
                                            defaultValue={undefined}
                                            type="date"
                                            label={translate('change-location:startDate')}
                                            id="createdOn"
                                            name="createdOn"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                                        {
                                            filter.status.map((item) =>
                                                <div key={item} className="no-padding col s12">
                                                    <div key={`${item}-div`} className="list sixth-text-color">
                                                        <i onClick={() => removedStatusFilter(item)} className={`mdi mdi-21px mdi-alpha-x-circle-outline`} />
                                                        {arrayDrop.find((f) => f.id === item).text}
                                                    </div>
                                                </div>)
                                        }
                                    </div>
                                </div> 
                            </div>
                        </li>
                    </ul> 
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button onClick={() => onFilter()} full="true" text={translate('delivery:general.search')} />
                    </div>
                </div>
                <div id="listorderGroups">
                    <ListPagination
                        page={props.orderGroups?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={orderGroups.map((item) => (
                            <>
                                {manageOrder && item?.orderGroupTypeId === ENUMS.eOrderGroupType.Delivery.value &&
                                    item.orderGroupStatusId !== ENUMS.eOrderGroupStatus.Finished.value &&
                                    (<span
                                        className="title sixth-text-color right"
                                        style={{ position: 'absolute', marginTop: '5px', right: '10px', zIndex: '999' }}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            props.leave(item?.orderGroupId, () => { setRefresh(refresh + 1) })
                                        }}
                                    ><i className="material-icons">lock_open</i>  </span>)
                                }
                                <Link
                                    className="row"
                                    to={{ pathname: props.location.pathname + `/details` }}
                                    onClick={() => {
                                        props.setGroup(item);
                                    }}
                                    style={{ display: 'block', marginBottom: '0px' }}>
                                    <span className="title sixth-text-color" style={{ display: 'block' }} >
                                        {item?.orderGroupId || ''}
                                    </span>
                                    <span className="col s12 second-text-color" style={{ display: 'block' }} >
                                        {getStatusGrouOrder(item.orderGroupStatusId)}
                                    </span>
                                    <div className="col s12 second-text-color" style={{ display: 'block' }} >
                                       {translate('line-picking:linepicking.creation')} {formatData(item?.createdOn || '')}
                                    </div>
                                    <span className="col s12 second-text-color" style={{ display: 'block' }} >
                                        {item?.lockedBy || item.updatedBy} -  {getUserNameToName(props?.usersFromElog, (item?.lockedBy || item.updatedBy))}
                                    </span>
                                    <span className="col s12 second-text-color" style={{ display: 'block' }} >
                                        {item?.abandoned ? translate('line-picking:linepicking.abandoned') : ''}
                                    </span>
                                </Link>
                            </>
                        ))}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        orderGroups: state.orderGroupReducer.orderGroups,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOrdersGroup: (filter, callback) => {
            dispatch(PickingService.getOrdersGroup(filter, callback));
        },
        setGroup: (item) => {
            dispatch(orderGroupAction.setOrderGroup(item));
        },
        leave: (orderGroupId, callback) => {
            dispatch(DeliveryService.leave(orderGroupId, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OrderGroupList)));
